module.exports = __webpack_public_path__ + "img/ms-1.e72c3cd9.webp";